export default [
  {
    path: window.pathApp + '/edicao-rapida/:field',
    name: 'edicao.rapida',
    component: () => import('@/components/EdicaoRapida'),
    meta: {
      login: false,
      title: "Edição rápida de dados",
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/edicao_rapida.js